module.exports = __webpack_public_path__ + "static/media/rsz_splash2.e5de6fe2.png";